export var Actions;
(function (Actions) {
    Actions["FACET_CLICKED"] = "searchResults/FACET_CLICKED";
    Actions["FILTER_CLICKED"] = "searchResults/FILTER_CLICKED";
    Actions["REMOVE_FILTER"] = "searchResults/REMOVE_FILTER";
    Actions["SORT_CHANGED"] = "searchResults/SORT_CHANGED";
    Actions["PAGE_NUMBER_CHANGED"] = "searchResults/PAGE_NUMBER_CHANGED";
    Actions["ITEM_CLICKED"] = "searchResults/ITEM_CLICKED";
    Actions["RESULTS_PER_PAGE_CHANGED"] = "searchResults/RESULTS_PER_PAGE_CHANGED";
    Actions["KEYPHRASE_CHANGED"] = "searchResults/KEYPHRASE_CHANGED";
    Actions["CLEAR_FILTERS"] = "searchResults/CLEAR_FILTERS";
})(Actions || (Actions = {}));
